import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SectionList from './StyledSectionList'
import Section from './StyledSection'
import { SECTIONS } from '../../../../../constants'
import { objectValues } from '../../../../utils/Object'

class SectionsMenu extends Component {
  render () {
    const {
      activeSection,
      onSectionClick
    } = this.props

    return (
      <SectionList>
        {
          objectValues(SECTIONS).map(section => {
            return (
              <Section key={section.name} onClick={() => onSectionClick(section.name)}
                className={section.name === activeSection.name ? 'active' : ''}>
                <span>
                  { section.text }
                </span>
              </Section>
            )
          })
        }
      </SectionList>
    )
  }
}

SectionsMenu.propTypes = {
  activeSection: PropTypes.object.isRequired,
  onSectionClick: PropTypes.func.isRequired
}

export default SectionsMenu
